var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"c-area-icon",attrs:{"src":_vm.computedSrc,"alt":"","width":"100","height":"100"}})}
var staticRenderFns = []

export { render, staticRenderFns }